export { default, INFO_BLOCK_WIDTH } from "./InfoBlock";
